import fetch from '@/api/fetch'
import SSE from '@/api/utils/sse'

const GenericError = 'Noe gikk galt. Ta kontakt med support@kvass.no'

const getErrorMessage = ({ message = GenericError, detail }) => (detail ? `${message}\n\n${detail}` : message)

export function request(url, options) {
  return fetch(url, options).catch(async err => {
    if (!(err instanceof Response)) throw getErrorMessage({ detail: err.message })

    const body = await err.json().catch(() => ({}))
    throw getErrorMessage({ message: body.message, detail: body.detail || `HTTP ${err.status}` })
  })
}

export function stream(url, options, onMessage) {
  return request(url, { ...options, headers: { ...options.headers, Accept: 'text/event-stream' } }).then(
    res =>
      new Promise((resolve, reject) => {
        let error
        const events = SSE(res)

        events.on('message', ({ message }) => onMessage(message))
        events.on('error', payload => (error = payload))
        events.on('finished', () => (error ? reject(getErrorMessage(error)) : resolve()))
      }),
  )
}
